class counselling {
	constructor() {
		// Counselling
		if (location.pathname.includes('counselling')) {
			window.addEventListener('unload', () => { });
			this.submitCounselling();
		}

		// Result
		if (location.pathname.includes('circulation') || location.pathname.includes('pure') || location.pathname.includes('relax')) {
			if (document.referrer.includes('counselling') !== true) {
				localStorage.removeItem('counselling');
				return;
			}

			this.resultCounselling();
		}
	};

	create(tagname, param = {}) {
		return Object.assign(document.createElement(tagname), param);
	}

	submitCounselling() {
		const wrapper = document.querySelector('[data-page-handle="counselling"] #pgCounselling');
		if (wrapper === null) return;

		const submit = wrapper.querySelector('#pgCounsellingSubmit');
		submit.addEventListener('click', () => {
			const error = { q: true, w: true };
			const point = { pure: 0, circulation: 0, relax: 0 };

			const questionaires = wrapper.querySelectorAll('input[name="questionaire"]:checked');
			for (const q of [...questionaires]) {
				error.q = false;

				for (const p of Object.keys(point)) {
					point[p] += +q.dataset[p] || 0;
				}
			}

			const worries = wrapper.querySelectorAll('input[name="worries"]');
			const worry = [...worries].filter(w => w.checked)[0];
			let selected = null;
			if (worry !== undefined) {
				error.w = false;
				selected = [...worries].indexOf(worry);
			}

			if (error.q === true || error.w === true) {
				wrapper.classList.add('pg-is-error');
				window.scroll({ top: 0, behavior: 'smooth' });
				return;
			}

			submit.classList.add('btn--loading');

			localStorage.removeItem('counselling');
			localStorage.setItem('counselling', selected);

			const max = Object.entries(point).reverse().reduce((prev, current) => {
				return prev[1] > current[1] ? prev : current
			});
			const is_food = location.pathname.includes('food-') ? true : false;
			const is_en = location.pathname.split('/').filter(Boolean).reverse()[0].includes('-en') ? true : false;
			location.href = `/pages/${is_food ? 'food-' : ''}${max[0]}${is_en ? '-en' : ''}`;
		});
	};

	resultCounselling() {
		const i = localStorage.getItem('counselling');
		const wrapper = document.querySelector('.accordion--container');
		if (wrapper === null) {
			return;
		}
		wrapper.classList.add('result');

		const templates = document.querySelectorAll(`template.counselling-result`);
		const content = templates[i].cloneNode(true).content;
		const container = wrapper.querySelector('[data-page-handle="counselling-result"] .pg-p-section__inner');
		container.append(content);

		for (const template of [...templates]) {
			template.remove();
		}

		if (location.pathname.includes('food-')) {
			const last = container.querySelector('.counselloing-result--product + .pg-p-section:not(.counselloing-result--product');
			if (last !== null) {
				last.remove();
			}

			const heading = container.querySelector('.pg-p-header h1');
			heading.addEventListener('click', () => {
				wrapper.classList.toggle('close');
			});
			Object.assign(heading, { className: 'accordion-trigger', innerText: 'お悩みの解決方法を知る' });

			const getHeight = () => {
				Object.assign(getHeight.__proto__, {
					height: getHeight.height ?? 0,
					max: getHeight.max ?? 0,
					offset: getHeight.offset ?? 0
				});

				const height = heading.getBoundingClientRect().height;
				if (height > getHeight.height) {
					getHeight.height = height;
				}

				const max = wrapper.getBoundingClientRect().height;
				if (max > getHeight.max) {
					getHeight.max = max;
				}

				const offset = +window.getComputedStyle(container.querySelector('.pg-p-header')).marginTop.replace('px', '');
				if (offset > getHeight.offset) {
					getHeight.offset = offset;
				}

				wrapper.style.cssText = `--heading-height: ${getHeight.height + getHeight.offset - 1}px; --wrapper-height: ${getHeight.max}px;`;
			};

			window.addEventListener('load', () => {
				getHeight();
				wrapper.classList.add('close');
			});
			window.addEventListener('resize', getHeight);
		}
		
		const bases = document.querySelectorAll('[data-page-handle="circulation"], [data-page-handle="pure"], [data-page-handle="relax"]');
		for (const base of bases) {
			const header = base.querySelector('.pg-p-header');
			header.querySelector('.pg-p-header__sub-heading').remove();
			header.querySelector('h1').innerHTML = `さらにアプローチするためには、<br>${base.dataset.pageHandle.toUpperCase()} コーチングがおすすめです`;
		}
	};
};

new counselling;